import { useTableStore } from "../../_stores"

import TableHeaders from "./_TableHeaders"
import TableBody from "./_TableBody"

import { useEffect, useRef } from "react"

const Table = ({ headers, rowData, className, onCellDataSave, onCellEdit, onDropdownClick, onDropdownOpen }, ref) => {
	const setTableData = useTableStore(state => state.setTableData)
	const tableData = useTableStore(state => state.tableData)
	const isTableLoading = useTableStore(state => state.isTableLoading)
	const setIsTableLoading = useTableStore(state => state.setIsTableLoading)
	const setOnCellDataSave = useTableStore(state => state.setOnCellDataSave)
	const setOnCellEdit = useTableStore(state => state.setOnCellEdit)
	const setOnDropdownClick = useTableStore(state => state.setOnDropdownClick)
	const setOnDropdownOpen = useTableStore(state => state.setOnDropdownOpen)

	const tableBodyRef = useRef(null)
	if (!ref) ref = useRef(null)

	const updateCell = (rowIndex, columnIndex, newValue, fireEvent = true, additionalParams = undefined) => {
		// get the row
		ref.current.tableBody.querySelector(`tr[data-index="${rowIndex}"]`).updateCell(columnIndex, newValue, fireEvent, additionalParams)
	}

	const getCellData = (rowIndex, columnIndex) => {
		// get the row
		return ref.current.tableBody.querySelector(`tr[data-index="${rowIndex}"]`).getCellData(columnIndex)
	}

	const getCell = (rowIndex, columnIndex) => {
		// get the row
		return ref.current.tableBody.querySelector(`tr[data-index="${rowIndex}"]`).getCell(columnIndex)
	}

	const getAllCells = () => {
		const rows = ref.current.tableBody.querySelectorAll('tr')
		const cells = []
		rows.forEach((row, rowIndex) => {
			const rowCells = row.querySelectorAll('td')
			rowCells.forEach((cell, cellIndex) => {
				cells.push(cell)
			})
		})
		return cells
	}

	useEffect(() => {
		// expose things through the ref
		ref.current.updateCell = updateCell
		ref.current.getCellData = getCellData
		ref.current.getCell = getCell
		ref.current.getAllCells = getAllCells
		ref.current.tableBody = tableBodyRef.current

		if (rowData && rowData.length > 0) {
			setTableData(rowData)
			setIsTableLoading(false)
		}

		onCellDataSave && setOnCellDataSave(onCellDataSave);
		onCellEdit && setOnCellEdit(onCellEdit);
		onDropdownClick && setOnDropdownClick(onDropdownClick);
		onDropdownOpen && setOnDropdownOpen(onDropdownOpen);
	}, [])
	return (
		<div className={`${className ? className : ''} ${isTableLoading ? '!opacity-40 !pointer-events-none' : ''} fk-table [&_th]:w-[250px] transition-all`} id="fkTable" ref={ref}>
			<table className="!z-[1]">
				<TableHeaders data={headers} tableRef={ref}/>
				<TableBody ref={tableBodyRef}/>
			</table>
		</div>
	)
}

export default React.forwardRef(Table)